"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconHumans = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 20 20",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M10 4.5C11.4497 4.5 12.625 5.6753 12.625 7.125C12.625 8.5747 11.4497 9.75 10 9.75C8.5503 9.75 7.375 8.5747 7.375 7.125C7.375 5.6753 8.5503 4.5 10 4.5M4.75 6.375C5.17 6.375 5.56 6.4875 5.8975 6.69C5.785 7.7625 6.1 8.8275 6.745 9.66C6.37 10.38 5.62 10.875 4.75 10.875C3.5074 10.875 2.5 9.8676 2.5 8.625C2.5 7.3824 3.5074 6.375 4.75 6.375M15.25 6.375C16.4926 6.375 17.5 7.3824 17.5 8.625C17.5 9.8676 16.4926 10.875 15.25 10.875C14.38 10.875 13.63 10.38 13.255 9.66C13.9 8.8275 14.215 7.7625 14.1025 6.69C14.44 6.4875 14.83 6.375 15.25 6.375M5.125 14.0625C5.125 12.51 7.3075 11.25 10 11.25C12.6925 11.25 14.875 12.51 14.875 14.0625L14.875 15.375 5.125 15.375 5.125 14.0625M1 15.375 1 14.25C1 13.2075 2.4175 12.33 4.3375 12.075C3.895 12.585 3.625 13.29 3.625 14.0625L3.625 15.375 1 15.375M19 15.375 16.375 15.375 16.375 14.0625C16.375 13.29 16.105 12.585 15.6625 12.075C17.5825 12.33 19 13.2075 19 14.25L19 15.375Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconHumans')(IconHumans);